import type { Currency, PromotionPlanId } from '@talkofthetown/shared';
import { useCallback } from 'react';
import { useToast } from '../components/Toasts';
import { friendlyError } from '../lib/errors';
import { payForPromotion, PaymentCancelled } from '../lib/payments';

/**
 * Pays for promoting a post and says how it went. Resolves true once paid. Call it after closing
 * the dialog it was chosen in: the checkout opens on the page.
 */
export function usePromote(): (
  postId: string,
  plan: PromotionPlanId,
  currency: Currency,
) => Promise<boolean> {
  const toast = useToast();
  return useCallback(
    async (postId, plan, currency) => {
      try {
        await payForPromotion(postId, plan, currency);
        toast('Paid, thank you! Your post is whispered more as soon as we’ve had a quick look.');
        return true;
      } catch (err) {
        toast(
          err instanceof PaymentCancelled
            ? 'Payment cancelled: nothing was charged. You can promote it later from My posts.'
            : friendlyError(err),
        );
        return false;
      }
    },
    [toast],
  );
}
